// NOTE: This function is not typesafe, but is called by analogous functions in lambda/ and web/

import { isNullOrUndefined } from './functions'
import { Integration } from './integration'

// whose typesafety is enforced by tests.
export function stringForIntegrationCommon(integration: string | null | undefined): string {
  const unknown = 'Unknown'
  if (integration === null || integration === undefined) {
    return unknown
  }

  switch (integration) {
    case 'appfolio':
      return 'AppFolio'
    case 'buildium':
      return 'Buildium'
    case 'demo':
      return 'PMS'
    case 'doorloop':
      return 'DoorLoop'
    case 'entrata':
      return 'Entrata'
    case 'mri':
      return 'MRI'
    case 'realpage':
      return 'RealPage'
    case 'resman':
      return 'ResMan'
    case 'yardi':
      return 'Yardi'
    default:
      throw new Error(`Unrecognized integration: ${integration}`)
  }
}

export function formatIntegrationName(integration: Integration | null | undefined): string {
  if (isNullOrUndefined(integration)) {
    return 'the PMS'
  }
  return stringForIntegrationCommon(integration)
}
